export default "__VITE_ASSET__BK5lFNyC__"